var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretVerticalThin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1368 0.316773L9 7.38872L1.86321 0.316772C1.65853 0.113946 1.38091 -4.99212e-07 1.09144 -5.24519e-07C0.801976 -5.49825e-07 0.524362 0.113946 0.319676 0.316772C0.114993 0.519596 8.04754e-07 0.794688 7.79678e-07 1.08153C7.54601e-07 1.36836 0.114993 1.64345 0.319676 1.84628L8.22823 9.68298C8.32954 9.78348 8.44985 9.86321 8.58228 9.9176C8.7147 9.972 8.85665 10 9 10C9.14335 10 9.2853 9.972 9.41773 9.9176C9.55015 9.86321 9.67046 9.78348 9.77177 9.68298L17.6803 1.84628C17.885 1.64346 18 1.36837 18 1.08153C18 0.794689 17.885 0.519598 17.6803 0.316773C17.4756 0.113948 17.198 8.83564e-07 16.9086 8.58257e-07C16.6191 8.32951e-07 16.3415 0.113948 16.1368 0.316773Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretVerticalThin);
export default __webpack_public_path__ + "static/media/caret-vertical-thin.67d564bc2193c5c62e6b1cdaf594b3db.svg";
export { ForwardRef as ReactComponent };